import React, { useState } from 'react';
import { Box, Button, Divider, IconButton, Text, TextButton, Tooltip } from '@wix/design-system';
import { DuplicateSmall } from '@wix/wix-ui-icons-common';
export const SUBJECT_LINE_SUGGESTIONS_WIDGET = 'SUBJECT_LINE_SUGGESTIONS_WIDGET';
export const SubjectLineSuggestionsWidget = _ref => {
  let {
    data: {
      subjects
    },
    context: {
      send,
      onWidgetAction,
      emitSideEffect
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginTop: 1,
    marginBottom: 1,
    gap: 2
  }, subjects.map((subject, idx) => {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      key: subject,
      gap: 2
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "3px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, "Suggestion ", idx + 1), /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "normal"
    }, subject)), /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "6px"
    }, /*#__PURE__*/React.createElement(UseTextButton, {
      value: subject,
      onClick: value => {
        emitSideEffect('set-subject', {
          newSubject: subject
        });
        onWidgetAction(SUBJECT_LINE_SUGGESTIONS_WIDGET, {
          action: 'use-text',
          value
        });
      }
    }), /*#__PURE__*/React.createElement(CopyButton, {
      value: subject,
      onClick: value => {
        navigator.clipboard.writeText(value);
        onWidgetAction(SUBJECT_LINE_SUGGESTIONS_WIDGET, {
          action: 'copy',
          value
        });
      }
    })), /*#__PURE__*/React.createElement(Box, {
      marginTop: 1,
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Divider, null)));
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 2,
    verticalAlign: "middle",
    marginTop: 1
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: () => {
      send('Can you give me some different subject line options?');
      onWidgetAction(SUBJECT_LINE_SUGGESTIONS_WIDGET, {
        action: 'create-again'
      });
    }
  }, "Create Again"), /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    weight: "normal",
    onClick: () => {
      send("I'd like to adjust these suggestions");
      onWidgetAction(SUBJECT_LINE_SUGGESTIONS_WIDGET, {
        action: 'refine'
      });
    }
  }, "Refine"))));
};
const UseTextButton = _ref2 => {
  let {
    value,
    onClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    priority: "secondary",
    onClick: e => {
      e.stopPropagation();
      onClick(value);
    }
  }, "Use text");
};
const CopyButton = _ref3 => {
  let {
    value,
    onClick
  } = _ref3;
  const [copied, setCopied] = useState(false);
  return /*#__PURE__*/React.createElement(Tooltip, {
    size: "small",
    content: copied ? 'Copied' : 'Copy text',
    moveBy: {
      x: 0,
      y: 6
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "tiny",
    priority: "secondary",
    onClick: e => {
      e.stopPropagation();
      onClick(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    }
  }, /*#__PURE__*/React.createElement(DuplicateSmall, null)));
};
//# sourceMappingURL=SubjectLineSuggestionsWidget.js.map